import React from 'react';
import { PersistentRepo } from '_src/shared/repo';

export default ({ text = '' }) => {
  const hasPIIPrivilege = PersistentRepo.get('privileges').some(({ id }) => id === 120);

  return <>{hasPIIPrivilege ? text : '********'}</>;
};
